import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'assets/img/sidebar.jpg',
    drawer: null,
    in_process: false,
    snack_text: '',
    snack_color: 'success',
    is_admin: false,
    access: [],
    default_error: 'An error has occurred! Please refresh this page.',
    roles: {
      // rebuild
      // 1 = Dashboard
      dashboard: 1,
      // 2 = Manager Forecast
      mforecast: 2,
      mforecast_update: 3,
      // 3 = Biometrics
      biometrics: 4,
      biometrics_export: 5,
      // 4 = Scheduler
      scheduler: 6,
      scheduler_manage: 7,
      scheduler_print: 8,
      // 5 = Crew List
      crewlist: 10,
      crewlist_manage_crew: 11,
      crewlist_manage_spes: 12,
      crewlist_import: 13,
      // 6 = Reports
      reports: 14,
      reports_shift_biometrics: 15,
      reports_shift_biometrics_summary: 32,
      // 7 = Stores
      stores: 16,
      stores_manage: 17,
      stores_switch: 18,
      // 8 = Users
      users: 19,
      users_manage: 20,
      // 9 = Settings
      settings: 21,
      settings_update: 22,
      // 10 = My Account
      myaccount: 23,
      // 12 = Advanced
      advanced: 27,
      // 2 = Manager Forecast
      mforecast_import: 28,
      // 4 = Scheduler
      scheduler_export: 29,
      // 7 = Stores
      stores_switch_profit_center: 30,
      stores_switch_patch: 31,
    },
    reports: {
      shift_biometrics_excel: {
        id: 212,
        access: 15, // roles.reports_shift_biometrics,
        description: 'Shift & Biometrics - ITG Template',
      },
      shift_biometrics_summary_excel: {
        id: 213,
        access: 32, // roles.reports_shift_biometrics_summary,
        description: 'Shift & Biometrics - Summary',
      },
    },
  },
  mutations: {
    set_admin (state, payload) {
      state.is_admin = payload
    },
    set_access (state, payload) {
      state.access = payload
    },
    SET_SNACK_TEXT (state, payload) {
      state.snack_text = payload
    },
    SET_SNACK_COLOR (state, payload) {
      state.snack_color = payload
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_IN_PROCESS (state, payload) {
      state.in_process = payload
    },
    Notify (state, payload) {
      if (typeof payload === 'string') {
        state.snack_text = payload
        state.snack_color = 'success'
      } else if (typeof payload === 'object') {
        if (payload.snack_text) { state.snack_text = payload.snack_text } else { state.snack_text = 'Saving data...' }
        if (payload.snack_color) { state.snack_color = payload.snack_color } else { state.snack_color = 'success' }
      }
    },
    CloseAlert (state, payload) {
      state.snack_text = payload
    },
    ShowError (state, payload) {
      state.snack_text = payload
    },
  },
  actions: {

  },
})
